import type { BannersResponseData } from '@kira-dancer/nadal'
import { IFrameGameURLEnum } from '@kira-dancer/nuxt-common/enums'
import { TYPE_DIVIDE } from '~/constants/app'
import {
  AccountRouteEnum,
  CardGameProviderEnum,
  DepositRouteEnum,
  PromotionRouteEnum,
  RoutesEnum,
  WithdrawRouteEnum,
} from '~/enums'
import type { SidebarItem } from '~/types/app'

export const DESKTOP_SIDEBAR_ITEMS = (brandName: string): SidebarItem[] => [
  {
    icon: 'icon-recent',
    title: 'Chơi gần đây',
    key: RoutesEnum.RecentPlayedGames,
    to: RoutesEnum.RecentPlayedGames,
    loginRequired: true,
  },
  {
    icon: 'icon-heart',
    title: 'Yêu thích',
    key: RoutesEnum.FavoriteGames,
    to: RoutesEnum.FavoriteGames,
    loginRequired: true,
  },
  {
    type: TYPE_DIVIDE,
    key: '',
    to: '',
  },
  {
    icon: 'icon-sport',
    title: 'Thể thao',
    key: RoutesEnum.Sports,
    to: RoutesEnum.Sports,
    items: [
      {
        title: 'K-Sports',
        key: IFrameGameURLEnum.K_SPORTS,
        to: IFrameGameURLEnum.K_SPORTS,
        isNewTab: true,
      },
      {
        title: 'C-Sports',
        key: IFrameGameURLEnum.M_SPORTS,
        to: IFrameGameURLEnum.M_SPORTS,
        isNewTab: true,
      },
      {
        title: 'M-Sports',
        key: IFrameGameURLEnum.P_SPORTS,
        to: IFrameGameURLEnum.P_SPORTS,
        isNewTab: true,
      },
      {
        title: 'P-Sports',
        key: IFrameGameURLEnum.C_SPORTS,
        to: IFrameGameURLEnum.C_SPORTS,
        isNewTab: true,
      },
      {
        title: 'A-Sports',
        key: IFrameGameURLEnum.I_SPORTS,
        to: IFrameGameURLEnum.I_SPORTS,
        isNewTab: true,
      },
      {
        title: 'E-Sports',
        key: IFrameGameURLEnum.ESPORTS,
        to: IFrameGameURLEnum.ESPORTS,
        loginRequired: true,
        isNewTab: true,
      },
      {
        title: 'Virtual Sports',
        key: IFrameGameURLEnum.VIRTUAL_SPORTS,
        to: IFrameGameURLEnum.VIRTUAL_SPORTS,
        loginRequired: true,
        isNewTab: true,
      },
    ],
  },
  {
    icon: 'icon-casino',
    title: 'Live Casino',
    key: RoutesEnum.LiveCasino,
    to: RoutesEnum.LiveCasino,
    items: [],
  },
  {
    icon: 'icon-table-games',
    title: 'Trò chơi',
    key: RoutesEnum.LobbyGame,
    to: RoutesEnum.LobbyGame,
    items: [
      {
        title: 'Slots',
        key: RoutesEnum.Slots,
        to: RoutesEnum.Slots,
      },
      {
        title: 'Bắn cá',
        key: RoutesEnum.Fishing,
        to: RoutesEnum.Fishing,
      },
      {
        title: 'Game bài',
        key: RoutesEnum.GameBai,
        to: RoutesEnum.GameBai,
      },
      {
        title: 'Game nhanh',
        key: RoutesEnum.InstantGames,
        to: RoutesEnum.InstantGames,
      },
      {
        title: 'Lô đề',
        key: RoutesEnum.Lode,
        to: RoutesEnum.Lode,
      },
      {
        title: 'Quay số',
        key: RoutesEnum.NumberGames,
        to: RoutesEnum.NumberGames,
      },
      {
        title: 'Game khác',
        key: RoutesEnum.OtherGames,
        to: RoutesEnum.OtherGames,
      },
    ],
  },
  {
    type: TYPE_DIVIDE,
    key: '',
    to: '',
  },
  {
    icon: 'icon-promotion',
    title: 'Khuyến mãi',
    key: PromotionRouteEnum.Promotion,
    to: PromotionRouteEnum.Promotion,
  },
  {
    icon: 'icon-news',
    title: 'Tin tức',
    key: RoutesEnum.News,
    to: RoutesEnum.News,
  },
  {
    icon: 'icon-info',
    title: `Về ${brandName.toUpperCase()}`,
    key: RoutesEnum.About,
    to: RoutesEnum.About,
  },
]

export type LoginURL =
  | IFrameGameURLEnum
  | RoutesEnum
  | DepositRouteEnum
  | WithdrawRouteEnum
  | AccountRouteEnum

export const LOGIN_REQUIRED_REDIRECT: LoginURL[] = [
  ...Object.values(DepositRouteEnum),
  ...Object.values(WithdrawRouteEnum),
  ...Object.values(AccountRouteEnum).filter((item) => item !== AccountRouteEnum.ResetPassword),
]

export const GAME_BANNERS: BannersResponseData[] = [
  {
    gameId: '',
    imgSrc: '/images/home/hr-banner-xoc-dia.webp',
    imgSrcMobile: '/images/home/hr-banner-xoc-dia-mb.webp',
    loginRequired: true,
    type: '',
    link: '',
    gameType: 'gamebai_url',
    provider: CardGameProviderEnum.Hitclub,
    wallet_type: '',
    tags: '',
    promotionPrevent: true,
    newTab: true,
  },
]

export const HR_BANNERS_DEFAULT: BannersResponseData[] = [
  {
    gameId: '',
    imgSrc: '/images/banner/banner-casino-pc.webp',
    imgSrcMobile: '/images/banner/banner-casino-mb.webp',
    link: RoutesEnum.LiveCasino,
    type: "LINK_TO",
    loginRequired: false
  },
]
